var render = function render(){var _vm=this,_c=_vm._self._c;return _c('zg-border',{attrs:{"border":_vm.border,"background-color":_vm.backgroundColor,"border-color":_vm.borderColor,"flipped-x":_vm.flippedX,"flipped-y":_vm.flippedY}})
}
var staticRenderFns = []

export { render, staticRenderFns }